import { render, staticRenderFns } from "./afterSales.vue?vue&type=template&id=b3fd9198&scoped=true&"
import script from "./afterSales.vue?vue&type=script&lang=js&"
export * from "./afterSales.vue?vue&type=script&lang=js&"
import style0 from "./afterSales.vue?vue&type=style&index=0&id=b3fd9198&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fd9198",
  null
  
)

export default component.exports